<template>
    <footer class="main-footer py-2">
        <div class="container">
            <div class="main-footer__content text-center-xs row">
                <div class="col-md-4">
                    {{ name }}<br />
                    {{ address }}<br />
                    <a :href="`tel:${phone}`" data-ga-track data-ga-category="Phone" data-ga-action="call" :data-ga-label="phone">{{ phone }}</a><br />
                    <a :href="`mailto:${email}`" data-ga-track data-ga-category="E-Mail" data-ga-action="click" :data-ga-label="email">{{ email }}</a>
                </div>
                <div class="col-md-4">
                    <nav>
                        <menu-component name="footer" list-class="main-footer__list"></menu-component>
                    </nav>
                </div>
                <div class="col-md-4">
                    Copyright &copy; {{ (new Date()).getFullYear() }} - Powered by <a href="https://racerfish.com" target="blank">Racerfish</a>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
import Menu from '#app#/components/package/RF/CMS/Menu.vue';
export default {
    data() {
        return {
            name: 'Name',
            address: 'Address',
            phone: '+41433998888',
            email: 'example@example.com'
        }
    },
    components: {
        'menu-component': Menu,
    }

}
</script>



// WEBPACK FOOTER //
// ../default-js/js/components/common/Footer.vue